<template>
    <div class="wb-stack"
         :class="classes"
         :style="styles"
    >
        <slot />
    </div>
</template>

<script setup lang="ts">
    import type { WBStackProps } from '~/src/shared/components/ui/grids/WBStack/types'

    const props = withDefaults(defineProps<WBStackProps>(), {
        gap: 'medium',
        align: 'center',
    })

    const classes = computed(() => ({
        ...(typeof props.gap === 'number' ? { '_gap-custom': true } : { [`_gap-${props.gap}`]: props.gap }),
        [`_align-${props.align}`]: props.align,
        '_stretch-items': props.stretchItems,
    }))

    const styles = ref({})

    if (typeof props.gap === 'number') {
        styles.value = { '--wb-stack-gap-custom': `${props.gap}px` }
    }
</script>

<style lang="scss">
    .wb-stack {
        --wb-stack-gap-xsmall: 12px;
        --wb-stack-gap-small: 16px;
        --wb-stack-gap-medium: 24px;
        --wb-stack-gap-large: 36px;

        display: flex;
        flex-flow: column;

        &._gap-xsmall {
            & > *:not(:first-child) {
                margin-top: var(--wb-stack-gap-xsmall);
            }
        }

        &._gap-small {
            & > *:not(:first-child) {
                margin-top: var(--wb-stack-gap-small);
            }
        }

        &._gap-medium {
            & > *:not(:first-child) {
                margin-top: var(--wb-stack-gap-medium);
            }
        }

        &._gap-large {
            & > *:not(:first-child) {
                margin-top: var(--wb-stack-gap-large);
            }
        }

        &._gap-custom {
            & > *:not(:first-child) {
                margin-top: var(--wb-stack-gap-custom);
            }
        }

        &._align-start {
            align-items: start;
        }

        &._align-center {
            align-items: center;
        }

        &._align-end {
            align-items: end;
        }

        &._stretch-items > * {
            width: 100%;
        }
    }
</style>
